import { OccasionPageLayout } from '@/components/seo/OccasionPageLayout';
import { getOccasion } from '@/data/occasions';
export default function LetterToAgingParent() {
  const o = getOccasion('letter-to-aging-parent')!;
  return <OccasionPageLayout occasion={o} />;
}
